module.exports = __webpack_public_path__ + "img/shopping_application_202604-2.b51a2ea9.jpg";